// 第1张
const imgAllA = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723606710851/%E6%88%BF%E8%BD%A6%E6%97%85%E8%A1%8C.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723607105604/%E6%88%BF%E8%BD%A6%E6%97%85%E8%A1%8C.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1727142580892/rv_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1727142580704/rv_m.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725614904598/3_pc_eu.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725614861021/3_m_eu.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725614862286/3_pc_uk.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725614887859/3_m_uk.jpg',
    },
};
const imgLocale1: any = {
    jp: imgAllA.JP,
    us: imgAllA.NA,
    ca: imgAllA.NA,
    br: imgAllA.NA,
    mx: imgAllA.NA,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
};
export default imgLocale1;
